import { FormSelectOption } from '../components/form/FormSelect';
import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';

export function useBooleanSelectOptions(): FormSelectOption<boolean | null>[] {
  const { t } = useTranslation();

  return useMemo(
    () => [
      {
        label: '',
        value: null,
      },
      {
        label: t('Yes'),
        value: true,
      },
      {
        label: t('No'),
        value: false,
      },
    ],
    [t],
  );
}
